import {
  SUBSCRIPTION_TYPE,
  SubscriptionRequestTable,
} from "api/interfaces/subscription.interface";
import { CpRequestItemStyled } from "./CpRequestStyled";
import PrimaryButton from "components/atoms/buttons/PrimaryButton";
import {
  changeServiceNameUnit,
  useKeyType,
} from "hook/subscription/useKeyType";
import TinyButton from "components/atoms/buttons/TinyButton";

type Props = {
  request: SubscriptionRequestTable;
  onOpenEmailToRequesterModal: () => void;
  onConfirm: () => void;
};

export default function CpRequestHistoryItem(props: Props): JSX.Element {
  const { request, onOpenEmailToRequesterModal, onConfirm } = props;
  const { durationMonthOptions } = useKeyType();

  return (
    <CpRequestItemStyled.ItemWrapper>
      <CpRequestItemStyled.Info>
        <li>
          <span className="label">Key Type</span>
          <span className="value">{request.keyType}</span>
        </li>
        <li>
          <span className="label">Requester</span>
          <span className="value">{request.requester}</span>
        </li>
        <li>
          <span className="label">
            {changeServiceNameUnit(request.keyType)}
          </span>
          <span className="value">{request.qty}</span>
        </li>

        <li>
          <span className="label">Installer</span>
          <span className="value">{request.installer}</span>
        </li>
        <li>
          <span className="label">Duration</span>
          <span className="value">
            {durationMonthOptions(
              request.keyType as SUBSCRIPTION_TYPE,
              true
            ).find((opt) => opt.value === String(request.duration))?.label ||
              "-"}
          </span>
        </li>
        <li className="message">
          <span className="label">Message</span>
          <span className="value">{request.message}</span>
        </li>
      </CpRequestItemStyled.Info>
      <CpRequestItemStyled.ButtonWrapper>
        <TinyButton
          label="Email to Requester"
          buttonType="cancel"
          onClickBtn={onOpenEmailToRequesterModal}
          data-testid="subscription-modal-cp-request-tiny-button-open-email-to-requester-modal"
        />

        <TinyButton
          label="Confirm"
          onClickBtn={onConfirm}
          data-testid="subscription-modal-cp-request-tiny-button-confirm"
        />
      </CpRequestItemStyled.ButtonWrapper>
    </CpRequestItemStyled.ItemWrapper>
  );
}
